export const actionFactory = (type) => 
  (payload) => 
    ({type, payload});




// WEBPACK FOOTER //
// ./src/util/redux-helpers.js